import { useDeviceType } from '@cian/ui-kit';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Questions } from 'shared/components/Questions';
import { caClickLinksQuestions } from 'shared/components/tracking';
import { selectDealType } from 'shared/selectors/dealType';
import { selectOfferType } from 'shared/selectors/offerType';
import { prepareCategoryCa } from 'shared/utils/prepareCategoryCa';

export const QuestionsContainer: React.FC = () => {
  const device = useDeviceType();

  const dealType = useSelector(selectDealType);

  const offerType = useSelector(selectOfferType);

  const caCategory = prepareCategoryCa(dealType, offerType);

  const handleOtherLinksClick = useCallback(
    (link: string, title: string, id: number) => {
      caClickLinksQuestions(caCategory, id, title, link);
    },
    [caCategory],
  );

  return <Questions dealType={dealType} onOtherLinks={handleOtherLinksClick} device={device} />;
};
